module.exports = __webpack_public_path__ + "dc60381c9a9f8000f1a260805d9dc9f8.svg";